<template>
    <div class="m-courseComment">
        <div class="comment-layout">

            <div class="comment-main">

                <div class="comment-post">
                    <img v-if="userInfo.avatar" class="avatar" :src="userInfo.avatar" alt="user avatar">
                    <img v-else class="avatar" src="../../assets/images/common/default_avatar.jpg" alt="user avatar">

                    <div class="textarea-box">
                        <el-input type="textarea" ref="commentInput" v-model="myComment" @focus="inputFocus" @blur="inputBlur" maxlength='500' show-word-limit></el-input>
                        <div class="comment-detail-reply-opreate" v-if="autofocuState||!!myComment">
                            <el-button class="commentBtn" type="primary" @click="commentCourse" size="small" :disabled="!myComment">评论</el-button>
                        </div>
                    </div>
                </div>

                <div class="comment-title">全部评论 <span>（{{commentTotal}}）</span></div>

                <div style="text-align:center;" v-if="commentList.length<=0">
                    <img src="/static/images/sofa.png" alt="">
                    <div style="line-height:60px;">暂无评论，快来抢沙发~</div>
                </div>

                <!-- 评论区域循环 -->
                <div class="comment-content" v-for="(item,index) in commentList" :key="index">
                    <!-- 评论人头像 -->
                    <div class="comment-owner-avatar">
                        <img :src="item.userInfo.avatar">
                    </div>
                    <!-- 评论内部详情 -->
                    <div class="comment-detail">
                        <!-- 昵称 -->
                        <p class="comment-owner-nick">
                            {{item.userInfo.name}}
                        </p>
                        <!-- 具体内容 -->
                        <p class="comment-detail-content">{{item.content}}</p>
                        <!-- 时间、点赞、评论等 -->
                        <div class="comment-detail-opreate">
                            <span class="comment-detail-opreate-time">{{item.time}}</span>
                            <div class="comment-detail-opreate-right">
                                <div class="comment-detail-opreate-thumbup" @click="giveTheThumbUp(item,index);">
                                    <i class="nucfont inuc-zan" v-if="!item.isLike"></i>
                                    <i class="nucfont inuc-zan" v-else style="color:#1afa29;"></i>
                                    <span :class="{'liked': item.isLike}" v-if="item.like>0">{{item.like}}</span>
                                </div>

                                <div class='comment-detail-opreate-reply' @click="replyFloor(index)">
                                    <i class="nucfont inuc-kaoshiguanli"></i>回复
                                </div>
                                <div class='comment-detail-opreate-del' v-if="userInfo.userID == item.userId" @click="startDelete(item,index)">
                                    <i class="nucfont inuc-delete"></i>删除
                                </div>
                            </div>
                        </div>

                        <!-- 回复时弹出输入框 -->
                        <div class="comment-detail-reply" v-if="replyIndex == index">
                            <el-input type="textarea" @blur="sonCommentBlur" v-model="sonComment" ref="sonComment" :placeholder="'回复' + item.userInfo.name + '...'" maxlength='50' show-word-limit></el-input>
                            <div class="comment-detail-reply-opreate">
                                <!-- <div @click="commentFloor(item,index)">评论</div> -->
                                <el-button class="commentBtn" type="primary" @click="commentFloor(item,index)" size="small" :disabled="!sonComment">评论</el-button>
                            </div>
                        </div>


                        <!-- 子评论区域 -->
                        <div class="comment-son" v-for="(im,ix) in item.children.list" :key="ix">
                            <!-- 子评论左侧头像区域 -->
                            <div class="comment-son-owner-avatar">
                                <img :src="im.userInfo.avatar">
                            </div>
                            <!-- 子评论右侧详情区域 -->
                            <div :class="item.children.list.length>1&&ix<item.children.list.length-1 ?'comment-son-detail comment-son-detail-multi': 'comment-son-detail'">
                                <!-- 子评论昵称 -->
                                <p class="comment-son-owner-nick">{{im.userInfo.name}}</p>
                                <!-- 子评论具体内容 -->
                                <p class="comment-son-detail-content">
                                    <span v-if="!!im.parentUserInfo">回复<span style="color:$color-theme;">{{im.parentUserInfo.name}}：</span></span>
                                    {{im.content}}
                                </p>
                                <!-- 子评论时间、点赞、回复等 -->
                                <div class="comment-son-detail-opreate">
                                    <span class="comment-son-detail-opreate-time">{{im.time}}</span>
                                    <div class="comment-son-detail-opreate-right">
                                        <div class="comment-son-detail-opreate-thumbup" @click="giveSonTheThumbUp(index,im,ix)">
                                            <i class="nucfont inuc-zan" v-if="!im.isLike"></i>
                                            <i class="nucfont inuc-zan" v-else style="color:#1afa29;"></i>
                                            <span :class="{'liked': im.isLike}" v-if="im.like>0">{{im.like}}</span>
                                        </div>

                                        <div class="comment-son-detail-opreate-reply" @click="replySonFloor(im.id)"><i class="nucfont inuc-kaoshiguanli"></i>回复</div>

                                        <div class='comment-son-detail-opreate-del' v-if="userInfo.userID == im.userId" @click="startDeleteSon(index,ix,im)">
                                            <i class="nucfont inuc-delete"></i>删除
                                        </div>
                                    </div>
                                </div>
                                <!-- 子评论回复时弹出输入框 -->
                                <div class="comment-son-detail-reply" v-if="replySonId == im.id">
                                    <el-input type="textarea" v-model="replySonComment" @blur="replySonCommentBlur" ref="replySonComment" :placeholder="'回复' + im.userInfo.name + '...'" maxlength='50' show-word-limit></el-input>
                                    <div class="comment-son-detail-reply-opreate">
<!--                                        <div @click="commentSonFloor(item,im,index)">评论</div>-->
                                        <el-button class="commentBtn" type="primary" @click="commentSonFloor(item,im,index)" size="small" :disabled="!replySonComment">评论</el-button>
                                    </div>
                                </div>
                                <!-- 展示条件：尚未加载全部、父节点评论数超过3条、子评论的最后一条 -->
                                <!-- <div class="viewSonMore" v-if="!noMoreSonState&&item.reply>3&&ix==item.children.list.length-1" @click="viewSonMore(item)">加载更多</div> -->
                            </div>
                        </div>
                        <div class="viewSonMore" v-if="!item.noMoreSonState&&item.reply>3" @click="viewSonMore(item,index)">加载更多</div>
                        <div style="width:100%;height:20px;"></div>
                    </div>
                </div>
                <div class="viewMore" v-if="!noMoreState&&commentTotal>10" @click="viewMore">查看更多 > </div>
                <div class="viewMore" v-if="noMoreState">没有更多了 ...</div>
            </div>

            <aside class="comment-side">
                <div class="cover-img">
                    <img v-if="courseData.cover" :src="courseData.cover" alt="封面">
                    <img v-else src="/static/images/preview.png" alt="封面">
                </div>
                <h3 class="course-title">{{courseData.name}}</h3>
                <ul>
                    <li class="item"><span>当前学习：</span>{{currentSection.name}}</li>
                    <li class="item"><span>创建人：</span>{{courseData.creatorName}}</li>
                    <li class="item"><span>描述：</span>{{courseData.description || '无'}}</li>
                </ul>
            </aside>
        </div>
        <el-dialog
            class="dialog-delete"
            title="确定删除该评论？"
            :visible.sync="dialogVisible"
            width="400px"
            :append-to-body="false"
            top="30vh"
        >
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false;" size="small">取 消</el-button>
                <el-button type="primary" @click="deleteFloor" size="small">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            class="dialog-delete"
            title="确定删除该评论？"
            :visible.sync="dialogSonVisible"
            width="400px"
            :append-to-body="false"
            top="30vh"
        >
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogSonVisible = false;" size="small">取 消</el-button>
                <el-button type="primary" @click="deleteSonFloor" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Vue from 'vue'
    export default {
        props: {
            courseData: {},
            courseID: String,
            chapterID: String,
            sectionID: String,
        },

        components: {

        },

        data() {
            return {
                myComment: '',
                sonComment: '',
                commentTotal: 0,
                commentList: [],
                replyIndex: null,
                replySonId: null,
                acceptCommentWorker: null,
                autofocuState: false,
                autofocus_single: true,
                noMoreState: false,
                noMoreSonState: false,
                count: 10,
                currentId: null,
                sonLimit: 3,
                sonCurrentComment: null,
                finishComment: false,
                replySonComment: '',
                dialogVisible: false,
                deleteID: null,
                deleteIndex: null,
                fatherIndex: null,
                sonIx: null,
                dialogSonVisible: false
            }
        },

        computed: {
            ...mapGetters([
                'userInfo',
            ]),
            currentSection() {
                return this.$parent.sections && this.$parent.sections.filter(item => item.id === this.sectionID)[0] || {}
            }
        },

        mounted() {
            //console.log(this.userInfo,'userInfo')
        },

        watch: {
            sectionID: {
                handler(v) {
                    console.log(v)
                    if (!v) return
                    this.getComment()
                },
                immediate: true
            }
        },

        methods: {
            startDelete(item,index) {
                this.dialogVisible = true
                this.deleteID = item.id;
                this.deleteIndex = index;
            },
            deleteFloor() {
                console.log('删除评论')
                this.$api.deleteComent(this.deleteID,{moduleId:this.courseID+'_'+this.chapterID+'_'+this.sectionID,moduleName:'course'}).then((res) => {
                    this.commentList.splice(this.deleteIndex,1);
                    this.commentTotal -= 1;
                    this.dialogVisible = false;
                }).catch( e => {})
            },
            startDeleteSon(index,ix,im) {
                this.dialogSonVisible = true;
                this.fatherIndex = index;
                this.sonIx = ix;
                this.sonIm = im;
            },
            deleteSonFloor() {
                this.$api.deleteComent(this.sonIm.id,{moduleId:this.courseID+'_'+this.chapterID+'_'+this.sectionID,moduleName:'course'}).then((res) => {
                    this.dialogSonVisible = false;
                    this.commentList[this.fatherIndex].children.list.splice(this.sonIx,1)
                })
            },
            inputFocus() {
                setTimeout(() => {
                    this.autofocuState = true;
                },200)
            },
            inputBlur() {
                if(!!this.myComment) {
                    // this.$nextTick(() =>{
                    //     this.$refs.commentInput.focus();
                    // })
                    // this.$refs.commentInput.focus();
                    return;
                };
                setTimeout(() => {
                    this.autofocuState = false;
                },200)
            },
            sonCommentBlur() {
                if(!!this.sonComment) {
                    // this.$nextTick(() =>{
                    //     this.$refs.sonComment[0].focus();
                    // })
                    return;
                };
                this.replyIndex = null;

                // setTimeout(() => {
                //     this.replyIndex = null;
                // },200)
            },
            replySonCommentBlur() {
                if(!!this.replySonComment) {
                    // this.$nextTick(() =>{
                    //     this.$refs.replySonComment[0].focus();
                    // })
                    return;
                };
                setTimeout(() => {
                    this.replySonId = null;
                },200)
            },
            commentCourse() {
                if(!this.myComment) return;
                this.$api.addCourseComment(this.courseID, this.chapterID, this.sectionID,{content:this.myComment}).then((res) => {
                    this.myComment = '';
                    let data = res.package;
                    data.children = {
                        currentComment: null,
                        list: [],
                        deleteState: false
                    }
                    this.commentList.unshift(data)
                    this.commentTotal += 1;
                    this.autofocuState = false;
                })
            },
            commentFloor(val,index) {
                if(!this.sonComment) return;
                this.$api.addCourseComment(this.courseID, this.chapterID, this.sectionID,{content:this.sonComment,parentId:val.id,parentUserId:val.userId,fromId:val.id})
                .then((res) => {
                    if(!res.package.id) {
                        this.$message.error(res.package.package)
                        return
                    }
                    this.commentList[index].children.list.unshift(res.package)
                    this.replyIndex = null
                    this.sonComment = ''
                })
            },
            commentSonFloor(val,im,index) {
                this.$api.addCourseComment(this.courseID, this.chapterID, this.sectionID,{content:this.replySonComment,parentId:im.id,parentUserId:im.userId,fromId:val.id})
                .then((res) => {
                    if(!res.package.id) {
                        this.$message.error(res.package.package)
                        return
                    }
                    this.commentList[index].children.list.unshift(res.package)
                    this.replySonId = null;
                    this.replySonComment = ''
                })
            },
            replyFloor(val) {
                this.sonComment = ''
                this.replyIndex = val;
                this.$nextTick(() =>{
                    this.$refs.sonComment[0].focus();
                })
            },
            replySonFloor(val) {
                this.replySonId = val;
                this.$nextTick(() =>{
                    this.$refs.replySonComment[0].focus();
                })
            },
            getComment() {
                this.noMoreState = false;
                this.$api.getCourseComment(this.courseID, this.chapterID, this.sectionID).then((res) => {
                    let target = res.package;
                    this.commentTotal = target.total;
                    this.commentList = target.comments;
                    this.commentList.forEach(item => {
                        item.deleteState = false;
                        item.children.list.forEach(im => {
                            im.deleteState = false;
                        })
                    })
                    this.currentId = target.currentComment;
                })
            },
            viewMore() {
                if(this.commentList.length>=this.commentTotal) {
                    this.noMoreState = true;
                    return
                }
                this.$api.getMoreCourseComment(this.courseID, this.chapterID, this.sectionID,this.count,this.currentId).then((res) => {
                    let target = res.package;
                    this.commentList = this.commentList.concat(target.comments);
                    this.currentId = target.currentComment;
                })
            },
            viewSonMore(val,index) {
                if(!this.sonCurrentComment) {
                    this.sonCurrentComment = val.children.currentComment;
                    console.log('初次加载',this.sonCurrentComment)
                }
                this.$api.getCourseSonComment(this.sonLimit,val.id,this.sonCurrentComment).then((res) => {
                    this.commentList[index].children.list = this.commentList[index].children.list.concat(res.package.children);
                    this.sonCurrentComment = res.package.currentComment
                    if(this.commentList[index].children.list.length >= res.package.count) {
                        this.sonCurrentComment = null;
                        console.log('加载完毕，清空sonCurrentComment')
                        this.commentList[index].noMoreSonState = true;
                    }
                })
            },
            giveTheThumbUp(val,index) {
                console.log('点赞')
                if(val.isLike) {
                    this.$api.cancelTheThumbUp(val.id,{moduleId:this.courseID+'_'+this.chapterID+'_'+this.sectionID,moduleName:'course'}).then((res) => {
                        console.log('取消点赞',res)
                        this.commentList[index].isLike = false
                        this.commentList[index].like = this.commentList[index].like - 1;
                    })
                    return
                }
                this.$api.giveTheThumbUp(val.id,{moduleId:this.courseID+'_'+this.chapterID+'_'+this.sectionID,moduleName:'course'}).then((res) => {
                    console.log('点赞',res)
                    this.commentList[index].isLike = true
                    this.commentList[index].like = this.commentList[index].like + 1;
                })
            },
            giveSonTheThumbUp(index,im,ix) {
                console.log('点赞')
                if(im.isLike) {
                    this.$api.cancelTheThumbUp(im.id,{moduleId:this.courseID+'_'+this.chapterID+'_'+this.sectionID,moduleName:'course'}).then((res) => {
                        console.log('取消点赞',res)
                        this.commentList[index].children.list[ix].isLike = false
                        this.commentList[index].children.list[ix].like = this.commentList[index].children.list[ix].like - 1;
                    })
                    return
                }
                this.$api.giveTheThumbUp(im.id,{moduleId:this.courseID+'_'+this.chapterID+'_'+this.sectionID,moduleName:'course'}).then((res) => {
                    console.log('取消点赞',res)
                    this.commentList[index].children.list[ix].isLike = true
                    this.commentList[index].children.list[ix].like = this.commentList[index].children.list[ix].like + 1;
                })
            }
        },
    }
</script>
<style scoped lang="scss">
    $width-layout: 1200px;
    @import '../../style/const.scss';

    .m-courseComment {
        //min-height: 100vh;
        padding: 30px 0 50px 0;
        background-color: #F0F0F0;
    }

    .comment-layout {
        display: flex;
        width: $width-layout;
        margin: 0 auto;
    }

    .comment-main {
        flex: 1;
        padding: 30px;
        margin-right: 30px;
        min-height: 600px;
        background-color: #fff;

        .comment-title {
            padding-top: 20px;
            font-size: 24px;
            margin-bottom: 20px;
            span {
                font-size: 18px;
                color: #9b9b9b;
            }
        }
        .comment-content {
            display: flex;
            min-height: 40px;
            .comment-owner-avatar {
                flex: 2;
                // background: $color-theme;
                text-align: center;
                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                }
            }
            .comment-detail {
                flex: 23;
                margin-right: 20px;
                margin-bottom: 10px;
                min-height: 100px;
                border-bottom: 0.5px #F1F1F1 solid;
                // background: #888;
                .comment-owner-nick {
                    line-height: 30px;
                    font-weight: bold;
                    color: $color-theme;
                }
                .comment-detail-content {
                    padding-top: 5px;
                }
                .comment-detail-opreate {
                    min-height: 40px;
                    line-height: 40px;
                    width: 100%;
                    position: relative;
                    .comment-detail-opreate-time {
                        position:absolute;
                        top:0;
                        bottom:0;
                        left:0;
                        margin:auto;
                        color:#888;
                    }
                    .comment-detail-opreate-right {
                        position:absolute;
                        top:0;
                        bottom:0;
                        right:0;
                        margin:auto;
                        color:#888;
                        .comment-detail-opreate-reply {
                            display: inline-block;
                            cursor: pointer;
                            margin: 0 5px;
                            i {
                                margin-right: 4px;
                            }
                        }
                        .comment-detail-opreate-thumbup{
                            display: inline-block;
                            cursor: pointer;
                            margin-right: 8px;
                        }
                        .comment-detail-opreate-del {
                            display: inline-block;
                            cursor: pointer;
                            margin: 0 5px;
                            i {
                                margin-right: 4px;
                            }
                        }
                    }
                }
                .comment-detail-reply {
                    min-height: 100px;
                    background: rgba(204, 210, 245, 0.2);
                    margin-bottom: 10px;
                    border-radius: 5px;
                    padding: 20px;
                    input {
                        width: 100%;
                        height: 40px;
                        line-height: 40px;
                        text-indent: 20px;
                        border-style: none;
                        border-radius: 5px;
                    }
                    .comment-detail-reply-opreate {
                        width: 100%;
                        min-height: 60px;
                        line-height: 60px;
                    }
                }
                .viewSonMore {
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    cursor: pointer;
                    color: $color-theme;
                    border-radius: 0 0 4px 4px;
                    background: #fafbfc;
                }
            }
            .comment-son {
                display: flex;
                padding: 10px;
                // background: rgba(204, 210, 245, 0.2);
                background: #fafbfc;
                border-radius: 4px 4px 0 0;
                .comment-son-owner-avatar {
                    flex: 2;
                    // background: $color-theme;
                    text-align: center;
                    img {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                    }
                }
                .comment-son-detail-multi {
                    border-bottom: 1px solid #f1f1f1;
                }
                .comment-son-detail {
                    flex: 23;
                    min-height: 100px;
                    // background: #888;
                    .comment-son-owner-nick {
                        line-height: 30px;
                        font-weight: bold;
                        color: $color-theme;
                    }
                    .comment-son-detail-content {
                        padding-top: 5px;
                    }
                    .comment-son-detail-opreate {
                        min-height: 40px;
                        line-height: 40px;
                        width: 100%;
                        position: relative;
                        .comment-son-detail-opreate-time {
                            position:absolute;
                            top:0;
                            bottom:0;
                            left:0;
                            margin:auto;
                            color:#888;
                        }
                        .comment-son-detail-opreate-right {
                            position:absolute;
                            top:0;
                            bottom:0;
                            right:0;
                            margin:auto;
                            color:#888;
                            .comment-son-detail-opreate-reply {
                                display: inline-block;
                                cursor: pointer;
                                margin: 0 5px;
                                i {
                                    margin-right: 4px;
                                }
                            }
                            .comment-son-detail-opreate-thumbup{
                                display: inline-block;
                                cursor: pointer;
                                margin-right: 8px;
                            }
                            .comment-son-detail-opreate-del {
                                display: inline-block;
                                cursor: pointer;
                                margin: 0 5px;
                                i {
                                    margin-right: 4px;
                                }
                            }
                        }
                    }
                    .comment-son-detail-reply {
                        min-height: 100px;
                        background: rgba(204, 210, 245, 0.2);
                        margin-bottom: 10px;
                        border-radius: 5px;
                        padding: 20px;
                        input {
                            width: 100%;
                            height: 40px;
                            line-height: 40px;
                            text-indent: 20px;
                            border-style: none;
                            border-radius: 5px;
                        }
                        .comment-son-detail-reply-opreate {
                            width: 100%;
                            min-height: 60px;
                            line-height: 60px;
                            div {
                                float: right;
                                cursor: pointer;
                                width: 60px;
                                height: 30px;
                                text-align: center;
                                line-height: 30px;
                                margin-top: 20px;
                                background: $color-theme;
                                color: white;
                                border-radius: 2px;
                            }
                        }
                    }
                }
            }
        }
        .commentBtn {
            float: right;
            margin-top: 20px;
        }
        .liked {
            color: #1afa29;
        }
        .viewMore {
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
            color: $color-theme;
        }
    }

    .comment-post {
        display: flex;
        .avatar {
            width: 58px;
            height: 58px;
            //border: 1px solid #ccc;
            border-radius: 50%;
        }
        .textarea-box {
            flex: 1;
            margin-left: 15px;
            .comment-detail-reply-opreate {
                width: 100%;
                min-height: 60px;
                line-height: 60px;
            }
        }
    }

    .comment-side {
        width: 320px;
        padding: 15px;
        background-color: #fff;
        .cover-img {
            width: 100%;
            //max-height: 158px;
            overflow: hidden;
            img {
                width: 100%;
                border-radius: 5px;
            }
        }
        .course-title {
            padding: 14px 0 20px;
            font-size: 16px;
            color: #333;
        }
        .item {
            color: #888;
            line-height: 40px;
            border-bottom: 1px solid #eee;
            span {
                color: #333;
                padding-right: 10px;
            }
        }
    }

    .dialog-delete {
        /deep/ .el-dialog__header {
            background-color: #666;
            border: none;
            .el-dialog__title {
                color: #fff;
            }
        }
        /deep/ .el-dialog__body {
            padding: 0;
        }
        /deep/ .el-dialog__footer {
            padding-top: 14px;
            background-color: #666;
        }
    }

</style>
